import Cookies from 'js-cookie';
import axios from 'axios';
import toast from 'react-hot-toast';
import { getStorefront } from "./storefront";

// Auth utility functions for debugging and token management

export const clearAuthData = () => {
  Cookies.remove("token");
  Cookies.remove("adminData");
};

const decodeJwtPayload = (token?: string) => {
  if (!token) return null;
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return null;
  }
};

/**
 * Restaurant whose branding (logo/theme) the current screen should use:
 * the admin's active location on /admin pages, otherwise the logged-in
 * employee's restaurant (Sales, kitchen and customer POS screens).
 */
export const getCurrentRestaurantId = (): string | undefined => {
  const adminInfo = decodeJwtPayload(Cookies.get("token"));
  const empInfo = decodeJwtPayload(Cookies.get("emptoken"));
  if (window.location.pathname.startsWith("/admin")) {
    // Master admin has no restaurant — it edits the platform-wide defaults.
    return adminInfo ? adminInfo.restaurantId || undefined : empInfo?.restaurantId;
  }
  // Public storefront (eduw.in/<slug>) takes priority for customer pages.
  const storefront = getStorefront();
  if (storefront) return storefront.restaurantId;
  return empInfo?.restaurantId || adminInfo?.restaurantId || undefined;
};

export const getTokenInfo = () => {
  const token = Cookies.get("token");
  console.log("Retrieved token:", token); // Debug log
  if (!token) {
    return null;
  }

  try {
    // Decode JWT token (without verification)
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload;
  } catch (error) {
    return null;
  }
};

export const isTokenValid = () => {
  const tokenInfo = getTokenInfo();
  if (!tokenInfo) return false;

  const now = Math.floor(Date.now() / 1000);
  const isValid = tokenInfo.exp > now;

  if (!isValid) {
    clearAuthData();
  }

  return isValid;
};

export const getAuthToken = () => {
  const token = Cookies.get("token");
  if (!token) return null;

  if (!isTokenValid()) {
    return null;
  }

  return token;
};

export const debugAuth = () => {
  // Debug function kept for future use but without console logs
  const token = Cookies.get("token");
  const tokenInfo = getTokenInfo();
  const isValid = isTokenValid();
  return { token, tokenInfo, isValid };
};

export const logout = () => {
  clearAuthData();
};

// In utils/auth.ts or wherever your verifyToken function is defined
export const verifyToken = async (setIsTokenValid: React.Dispatch<React.SetStateAction<boolean | null>>) => {
  try {
    const token = Cookies.get('emptoken');
    if (!token) {
      setIsTokenValid(false); // Token is invalid
      return null;
    }

  const response = await axios.get(
  `${process.env.REACT_APP_API_URL}/verification`,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true
    });

    if (response.data.success) {
      setIsTokenValid(true); // Token is valid
      return response.data.user;
    } else {
      setIsTokenValid(false); // Invalid token
      return null;
    }
  } catch (error: any) {
    // A suspended/trial-expired/canceled restaurant blocks its employees'
    // POS/Kitchen sessions too — surface why, then log them out.
    if (error.response?.status === 402) {
      toast.error(
        error.response.data?.message ||
          "Your restaurant's account is no longer active. Please contact your admin.",
      );
      Cookies.remove('emptoken');
    } else {
      console.error('Token verification failed:', error);
    }
    setIsTokenValid(false); // Invalid token or expired
    return null;
  }
};

export const verifyadminToken = async (setIsTokenValid: React.Dispatch<React.SetStateAction<boolean | null>>) => {
  try {
    const token = Cookies.get('token');
    if (!token) {
      setIsTokenValid(false); // Token is invalid
      return null;
    }

      const response = await axios.get(
  `${process.env.REACT_APP_API_URL}/verification`,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true
    });


    if (response.data.success) {
      setIsTokenValid(true); // Token is valid
      return response.data.user;
    } else {
      setIsTokenValid(false); // Invalid token
      return null;
    }
  } catch (error) {
    console.error('Token verification failed:', error);
    setIsTokenValid(false); // Invalid token or expired
    return null;
  }
};
